import { api } from "./baseapi";
export const addTagTypes = [
  "Carepath Data",
  "Patient",
  "Order",
  "Delete Order",
  "External Lumonus AI",
  "OrderAssignment",
  "users",
  "FeatureSwitches",
  "SiteGroup",
  "Site",
  "DoseAndObjectives",
  "OrganAtRisk",
  "Scorecard",
  "WalkthroughAttachment",
  "Comment",
  "CommentAttachment",
  "Notifications",
  "Demo Data",
  "Deployment",
  "Rainbow Data",
  "Rainbow List Data",
  "TenantConfig",
  "Iguana",
  "Appointments",
  "Device",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      protocolApiV1ListProtocols: build.query<
        ProtocolApiV1ListProtocolsApiResponse,
        ProtocolApiV1ListProtocolsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/protocols`,
          params: {
            tenant_id: queryArg.tenantId,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["Carepath Data"],
      }),
      protocolApiV1ListData: build.query<
        ProtocolApiV1ListDataApiResponse,
        ProtocolApiV1ListDataApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/listdata`,
          params: {
            categories: queryArg.categories,
            tenant_ids: queryArg.tenantIds,
          },
        }),
        providesTags: ["Carepath Data"],
      }),
      protocolApiV1TreatmentSiteData: build.query<
        ProtocolApiV1TreatmentSiteDataApiResponse,
        ProtocolApiV1TreatmentSiteDataApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/treatment-site`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Carepath Data"],
      }),
      protocolApiV1OrganData: build.query<
        ProtocolApiV1OrganDataApiResponse,
        ProtocolApiV1OrganDataApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/organ`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Carepath Data"],
      }),
      webApiV1GetPatient: build.query<
        WebApiV1GetPatientApiResponse,
        WebApiV1GetPatientApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/patients/${queryArg.patientId}`,
        }),
        providesTags: ["Patient"],
      }),
      webApiV1UpdatePatient: build.mutation<
        WebApiV1UpdatePatientApiResponse,
        WebApiV1UpdatePatientApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/patients/${queryArg.patientId}`,
          method: "PATCH",
          body: queryArg.patientIn,
        }),
        invalidatesTags: ["Patient"],
      }),
      webApiV1Order: build.query<WebApiV1OrderApiResponse, WebApiV1OrderApiArg>(
        {
          query: (queryArg) => ({
            url: `/ord/api/v1/orders/${queryArg.orderId}`,
          }),
          providesTags: ["Order", "Delete Order"],
        },
      ),
      webApiV1UpdateOrder: build.mutation<
        WebApiV1UpdateOrderApiResponse,
        WebApiV1UpdateOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}`,
          method: "PATCH",
          body: queryArg.orderIn,
        }),
        invalidatesTags: ["Order"],
      }),
      webApiV1DeleteClonedOrder: build.mutation<
        WebApiV1DeleteClonedOrderApiResponse,
        WebApiV1DeleteClonedOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Delete Order"],
      }),
      webApiV1CreateOrder: build.mutation<
        WebApiV1CreateOrderApiResponse,
        WebApiV1CreateOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders`,
          method: "POST",
          params: {
            tenant_id: queryArg.tenantId,
            treating_department: queryArg.treatingDepartment,
          },
        }),
        invalidatesTags: ["Order"],
      }),
      webApiV1ListOrders: build.query<
        WebApiV1ListOrdersApiResponse,
        WebApiV1ListOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders`,
          params: {
            ids: queryArg.ids,
            recent: queryArg.recent,
            filter: queryArg.filter,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["Order", "Delete Order"],
      }),
      webApiV1CloneOrder: build.mutation<
        WebApiV1CloneOrderApiResponse,
        WebApiV1CloneOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/edit`,
          method: "POST",
        }),
        invalidatesTags: ["Order"],
      }),
      webApiV1RejectOrder: build.mutation<
        WebApiV1RejectOrderApiResponse,
        WebApiV1RejectOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/reject`,
          method: "PATCH",
          body: queryArg.rejectOrderIn,
        }),
        invalidatesTags: ["Order"],
      }),
      webApiV1CreateFhirOrder: build.mutation<
        WebApiV1CreateFhirOrderApiResponse,
        WebApiV1CreateFhirOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/fhir/order`,
          method: "POST",
          body: queryArg.lumonusAiOrderIn,
        }),
        invalidatesTags: ["External Lumonus AI"],
      }),
      webApiV1VoidFhirOrder: build.mutation<
        WebApiV1VoidFhirOrderApiResponse,
        WebApiV1VoidFhirOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/fhir/void_order`,
          method: "POST",
          body: queryArg.lumonusAiOrderIn,
        }),
        invalidatesTags: ["External Lumonus AI"],
      }),
      webApiV1OrderStatusChange: build.query<
        WebApiV1OrderStatusChangeApiResponse,
        WebApiV1OrderStatusChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/status`,
          params: {
            status_name: queryArg.statusName,
          },
        }),
        providesTags: ["Order"],
      }),
      webApiV1SearchOrders: build.query<
        WebApiV1SearchOrdersApiResponse,
        WebApiV1SearchOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order-search`,
          params: {
            search_text: queryArg.searchText,
            site_filter: queryArg.siteFilter,
            physician_filter: queryArg.physicianFilter,
            status_filter: queryArg.statusFilter,
            quick_filter: queryArg.quickFilter,
            assigned_to_filter: queryArg.assignedToFilter,
            ordering: queryArg.ordering,
          },
        }),
        providesTags: ["Order", "Delete Order"],
      }),
      webApiV1RelatedPrescriptions: build.query<
        WebApiV1RelatedPrescriptionsApiResponse,
        WebApiV1RelatedPrescriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/related-prescriptions`,
          params: {
            order_id: queryArg.orderId,
          },
        }),
        providesTags: ["Order"],
      }),
      webApiV1GetRtStructs: build.query<
        WebApiV1GetRtStructsApiResponse,
        WebApiV1GetRtStructsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/rt-structs`,
        }),
        providesTags: ["Order"],
      }),
      webApiV1GetIsocenterOptions: build.query<
        WebApiV1GetIsocenterOptionsApiResponse,
        WebApiV1GetIsocenterOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/isocenter_options`,
          params: {
            template_name: queryArg.templateName,
            rt_struct_id: queryArg.rtStructId,
            order_id: queryArg.orderId,
          },
        }),
        providesTags: ["Order"],
      }),
      webApiV1SetOrderAssignment: build.mutation<
        WebApiV1SetOrderAssignmentApiResponse,
        WebApiV1SetOrderAssignmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/assignment`,
          method: "PUT",
          body: queryArg.orderAssignmentIn,
        }),
        invalidatesTags: ["OrderAssignment", "Order"],
      }),
      webApiV1GetAllAssignablePlanners: build.query<
        WebApiV1GetAllAssignablePlannersApiResponse,
        WebApiV1GetAllAssignablePlannersApiArg
      >({
        query: () => ({ url: `/ord/api/v1/assignable-planners` }),
        providesTags: ["OrderAssignment"],
      }),
      webApiV1GetTenantPhysicians: build.query<
        WebApiV1GetTenantPhysiciansApiResponse,
        WebApiV1GetTenantPhysiciansApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/users/physicians`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["users"],
      }),
      webApiV1GetUserFeatureSwitches: build.query<
        WebApiV1GetUserFeatureSwitchesApiResponse,
        WebApiV1GetUserFeatureSwitchesApiArg
      >({
        query: () => ({ url: `/ord/api/v1/users/features` }),
        providesTags: ["FeatureSwitches"],
      }),
      webApiV1GetFeatureSwitchesForOrder: build.query<
        WebApiV1GetFeatureSwitchesForOrderApiResponse,
        WebApiV1GetFeatureSwitchesForOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/users/features/order/${queryArg.orderId}`,
        }),
        providesTags: ["FeatureSwitches"],
      }),
      webApiV1GetUserPreferences: build.query<
        WebApiV1GetUserPreferencesApiResponse,
        WebApiV1GetUserPreferencesApiArg
      >({
        query: () => ({ url: `/ord/api/v1/users/preferences` }),
        providesTags: ["FeatureSwitches"],
      }),
      webApiV1UpdateUserPreferences: build.mutation<
        WebApiV1UpdateUserPreferencesApiResponse,
        WebApiV1UpdateUserPreferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/users/preferences`,
          method: "PATCH",
          body: queryArg.userPreferenceIn,
        }),
        invalidatesTags: ["FeatureSwitches"],
      }),
      webApiV1ListSiteGroups: build.query<
        WebApiV1ListSiteGroupsApiResponse,
        WebApiV1ListSiteGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/site-groups`,
        }),
        providesTags: ["SiteGroup", "Order"],
      }),
      webApiV1CreateSiteGroup: build.mutation<
        WebApiV1CreateSiteGroupApiResponse,
        WebApiV1CreateSiteGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/site-groups`,
          method: "POST",
          params: {
            protocol_id: queryArg.protocolId,
            manual_site_name: queryArg.manualSiteName,
            manual_site_specify: queryArg.manualSiteSpecify,
          },
        }),
        invalidatesTags: ["SiteGroup", "Order"],
      }),
      webApiV1UpdateSiteGroup: build.mutation<
        WebApiV1UpdateSiteGroupApiResponse,
        WebApiV1UpdateSiteGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/site-groups/${queryArg.siteGroupId}`,
          method: "PATCH",
          body: queryArg.siteGroupIn,
        }),
        invalidatesTags: ["SiteGroup", "Order"],
      }),
      webApiV1DeleteSiteGroup: build.mutation<
        WebApiV1DeleteSiteGroupApiResponse,
        WebApiV1DeleteSiteGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/site-groups/${queryArg.siteGroupId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SiteGroup", "Order"],
      }),
      webApiV1ListSites: build.query<
        WebApiV1ListSitesApiResponse,
        WebApiV1ListSitesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/site-groups/${queryArg.siteGroupId}/sites`,
        }),
        providesTags: ["Site"],
      }),
      webApiV1CreateSite: build.mutation<
        WebApiV1CreateSiteApiResponse,
        WebApiV1CreateSiteApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/site-groups/${queryArg.siteGroupId}/sites`,
          method: "POST",
          params: {
            manual_site_name: queryArg.manualSiteName,
            manual_site_specify: queryArg.manualSiteSpecify,
          },
        }),
        invalidatesTags: ["Site", "SiteGroup", "Order"],
      }),
      webApiV1UpdateSite: build.mutation<
        WebApiV1UpdateSiteApiResponse,
        WebApiV1UpdateSiteApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/sites/${queryArg.siteId}`,
          method: "PUT",
          body: queryArg.siteOut,
        }),
        invalidatesTags: ["Site", "SiteGroup", "Order", "DoseAndObjectives"],
      }),
      webApiV1DeleteSite: build.mutation<
        WebApiV1DeleteSiteApiResponse,
        WebApiV1DeleteSiteApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/sites/${queryArg.siteId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Site", "SiteGroup", "Order"],
      }),
      webApiV1ListOars: build.query<
        WebApiV1ListOarsApiResponse,
        WebApiV1ListOarsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/site-groups/${queryArg.siteGroupId}/oars`,
        }),
        providesTags: ["OrganAtRisk"],
      }),
      webApiV1CreateOar: build.mutation<
        WebApiV1CreateOarApiResponse,
        WebApiV1CreateOarApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/site-groups/${queryArg.siteGroupId}/oars`,
          method: "POST",
        }),
        invalidatesTags: ["OrganAtRisk"],
      }),
      webApiV1UpdateOar: build.mutation<
        WebApiV1UpdateOarApiResponse,
        WebApiV1UpdateOarApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/oars/${queryArg.oarId}`,
          method: "PUT",
          body: queryArg.organAtRiskIn,
        }),
        invalidatesTags: ["OrganAtRisk"],
      }),
      webApiV1DeleteOar: build.mutation<
        WebApiV1DeleteOarApiResponse,
        WebApiV1DeleteOarApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/oars/${queryArg.oarId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["OrganAtRisk"],
      }),
      webApiV1ListTargetObjectives: build.query<
        WebApiV1ListTargetObjectivesApiResponse,
        WebApiV1ListTargetObjectivesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/sites/${queryArg.siteId}/target-objectives`,
        }),
        providesTags: ["DoseAndObjectives"],
      }),
      webApiV1UpdateTargetObjective: build.mutation<
        WebApiV1UpdateTargetObjectiveApiResponse,
        WebApiV1UpdateTargetObjectiveApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/sites/${queryArg.siteId}/target-objectives/${queryArg.targetObjectiveId}`,
          method: "PUT",
          body: queryArg.targetObjectiveIn,
        }),
        invalidatesTags: ["DoseAndObjectives"],
      }),
      webApiV1ListAttachments: build.query<
        WebApiV1ListAttachmentsApiResponse,
        WebApiV1ListAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/attachments`,
        }),
        providesTags: ["Scorecard"],
      }),
      webApiV1CreateAttachment: build.mutation<
        WebApiV1CreateAttachmentApiResponse,
        WebApiV1CreateAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/attachments`,
          method: "POST",
          body: queryArg.scorecardAttachmentIn,
        }),
        invalidatesTags: ["Scorecard"],
      }),
      webApiV1DeleteAttachment: build.mutation<
        WebApiV1DeleteAttachmentApiResponse,
        WebApiV1DeleteAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/attachments/${queryArg.attachmentId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Scorecard"],
      }),
      webApiV1ReadAttachment: build.mutation<
        WebApiV1ReadAttachmentApiResponse,
        WebApiV1ReadAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/attachments/${queryArg.attachmentId}`,
          method: "PUT",
        }),
        invalidatesTags: ["Scorecard"],
      }),
      webApiV1ListWalkthroughAttachments: build.query<
        WebApiV1ListWalkthroughAttachmentsApiResponse,
        WebApiV1ListWalkthroughAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/walkthrough-attachments`,
        }),
        providesTags: ["WalkthroughAttachment"],
      }),
      webApiV1CreateWalkthroughAttachmentUploads: build.mutation<
        WebApiV1CreateWalkthroughAttachmentUploadsApiResponse,
        WebApiV1CreateWalkthroughAttachmentUploadsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/walkthrough-attachments`,
          method: "POST",
          body: queryArg.fileNames,
        }),
        invalidatesTags: ["WalkthroughAttachment"],
      }),
      webApiV1DeleteWalkthroughAttachment: build.mutation<
        WebApiV1DeleteWalkthroughAttachmentApiResponse,
        WebApiV1DeleteWalkthroughAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/walkthrough-attachments/${queryArg.attachmentId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["WalkthroughAttachment"],
      }),
      webApiV1UpdateWalkthroughAttachment: build.mutation<
        WebApiV1UpdateWalkthroughAttachmentApiResponse,
        WebApiV1UpdateWalkthroughAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/orders/${queryArg.orderId}/walkthrough-attachments/${queryArg.fileId}/`,
          method: "PATCH",
          params: {
            upload_complete: queryArg.uploadComplete,
            sent_for_review: queryArg.sentForReview,
            read: queryArg.read,
          },
        }),
        invalidatesTags: ["WalkthroughAttachment"],
      }),
      commentsApiV1GetCommentForOrder: build.query<
        CommentsApiV1GetCommentForOrderApiResponse,
        CommentsApiV1GetCommentForOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order-groups/${queryArg.orderGroupId}/comments`,
        }),
        providesTags: ["Comment"],
      }),
      commentsApiV1PostComment: build.mutation<
        CommentsApiV1PostCommentApiResponse,
        CommentsApiV1PostCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order-groups/${queryArg.orderGroupId}/comments`,
          method: "POST",
          body: queryArg.commentIn,
        }),
        invalidatesTags: ["Comment"],
      }),
      commentsApiV1CreateAttachment: build.mutation<
        CommentsApiV1CreateAttachmentApiResponse,
        CommentsApiV1CreateAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order-groups/${queryArg.orderGroupId}/attachments`,
          method: "POST",
          body: queryArg.attachmentIn,
        }),
        invalidatesTags: ["Comment", "CommentAttachment"],
      }),
      commentsApiV1GetUnreadCommentCount: build.query<
        CommentsApiV1GetUnreadCommentCountApiResponse,
        CommentsApiV1GetUnreadCommentCountApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/unread-comment-count/${queryArg.orderGroupId}`,
        }),
        providesTags: ["Comment"],
      }),
      commentsApiV1GetAllUnreadComments: build.query<
        CommentsApiV1GetAllUnreadCommentsApiResponse,
        CommentsApiV1GetAllUnreadCommentsApiArg
      >({
        query: () => ({ url: `/ord/api/v1/unread-comment-count/` }),
        providesTags: ["Comment"],
      }),
      commentsApiV1SetCommentsRead: build.mutation<
        CommentsApiV1SetCommentsReadApiResponse,
        CommentsApiV1SetCommentsReadApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/set-comments-read/${queryArg.orderGroupId}`,
          method: "PATCH",
        }),
        invalidatesTags: ["Comment", "Notifications"],
      }),
      webApiV1UpdateUserActivityLastViewed: build.mutation<
        WebApiV1UpdateUserActivityLastViewedApiResponse,
        WebApiV1UpdateUserActivityLastViewedApiArg
      >({
        query: () => ({
          url: `/ord/api/v1/user_activity/notifications_last_viewed`,
          method: "PUT",
        }),
        invalidatesTags: ["Notifications"],
      }),
      webApiV1ResetDemoData: build.mutation<
        WebApiV1ResetDemoDataApiResponse,
        WebApiV1ResetDemoDataApiArg
      >({
        query: () => ({ url: `/ord/api/v1/reset_demo_data`, method: "POST" }),
        invalidatesTags: ["Demo Data", "Order"],
      }),
      automationIntegrationDeploymentApiV1GetRedisServerStatus: build.query<
        AutomationIntegrationDeploymentApiV1GetRedisServerStatusApiResponse,
        AutomationIntegrationDeploymentApiV1GetRedisServerStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/redis-server-status/${queryArg.tenantId}`,
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationDeploymentApiV1GetConsumerInfo: build.query<
        AutomationIntegrationDeploymentApiV1GetConsumerInfoApiResponse,
        AutomationIntegrationDeploymentApiV1GetConsumerInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/consumer-info/${queryArg.tenantId}`,
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationDeploymentApiV1GetActiveJobsEndpoint: build.query<
        AutomationIntegrationDeploymentApiV1GetActiveJobsEndpointApiResponse,
        AutomationIntegrationDeploymentApiV1GetActiveJobsEndpointApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/active-jobs/${queryArg.tenantId}`,
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationDeploymentApiV1GetPendingJobsEndpoint: build.query<
        AutomationIntegrationDeploymentApiV1GetPendingJobsEndpointApiResponse,
        AutomationIntegrationDeploymentApiV1GetPendingJobsEndpointApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/pending-jobs/${queryArg.tenantId}`,
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationDeploymentApiV1DispatchHealthcheckRequests:
        build.mutation<
          AutomationIntegrationDeploymentApiV1DispatchHealthcheckRequestsApiResponse,
          AutomationIntegrationDeploymentApiV1DispatchHealthcheckRequestsApiArg
        >({
          query: (queryArg) => ({
            url: `/ord/api/v1/deployments/healthcheck`,
            method: "POST",
            params: {
              tenant_ids: queryArg.tenantIds,
            },
          }),
          invalidatesTags: ["Deployment"],
        }),
      automationIntegrationDeploymentApiV1GetHealthcheckInfo: build.query<
        AutomationIntegrationDeploymentApiV1GetHealthcheckInfoApiResponse,
        AutomationIntegrationDeploymentApiV1GetHealthcheckInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/healthcheck`,
          params: {
            tenant_ids: queryArg.tenantIds,
          },
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationDeploymentApiV1GetConsumerOverview: build.query<
        AutomationIntegrationDeploymentApiV1GetConsumerOverviewApiResponse,
        AutomationIntegrationDeploymentApiV1GetConsumerOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/deployments/consumer-overview`,
          params: {
            tenant_ids: queryArg.tenantIds,
          },
        }),
        providesTags: ["Deployment"],
      }),
      automationIntegrationApiV1GetStructures: build.query<
        AutomationIntegrationApiV1GetStructuresApiResponse,
        AutomationIntegrationApiV1GetStructuresApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/structures`,
          params: {
            rt_struct_id: queryArg.rtStructId,
            since_timestamp: queryArg.sinceTimestamp,
          },
        }),
        providesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1RequestStructures: build.mutation<
        AutomationIntegrationApiV1RequestStructuresApiResponse,
        AutomationIntegrationApiV1RequestStructuresApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/structures`,
          method: "POST",
          params: {
            rt_struct_id: queryArg.rtStructId,
          },
        }),
        invalidatesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1ListTemplates: build.query<
        AutomationIntegrationApiV1ListTemplatesApiResponse,
        AutomationIntegrationApiV1ListTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/eclipse/templates`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Rainbow List Data"],
      }),
      automationIntegrationApiV1ListTemplateDetails: build.query<
        AutomationIntegrationApiV1ListTemplateDetailsApiResponse,
        AutomationIntegrationApiV1ListTemplateDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/eclipse/templates/${queryArg.templateName}`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Rainbow List Data"],
      }),
      automationIntegrationApiV1ListMachines: build.query<
        AutomationIntegrationApiV1ListMachinesApiResponse,
        AutomationIntegrationApiV1ListMachinesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/machines`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Rainbow List Data"],
      }),
      automationIntegrationApiV1ListDensityOverrides: build.query<
        AutomationIntegrationApiV1ListDensityOverridesApiResponse,
        AutomationIntegrationApiV1ListDensityOverridesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/density-overrides`,
          params: {
            tenant_id: queryArg.tenantId,
          },
        }),
        providesTags: ["Rainbow List Data"],
      }),
      automationIntegrationApiV1GetPlanningSteps: build.query<
        AutomationIntegrationApiV1GetPlanningStepsApiResponse,
        AutomationIntegrationApiV1GetPlanningStepsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/planning-steps`,
        }),
        providesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1GetPlanningProgress: build.query<
        AutomationIntegrationApiV1GetPlanningProgressApiResponse,
        AutomationIntegrationApiV1GetPlanningProgressApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/planning-progress`,
        }),
        providesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1GetImportedDataHasRefreshedSince: build.query<
        AutomationIntegrationApiV1GetImportedDataHasRefreshedSinceApiResponse,
        AutomationIntegrationApiV1GetImportedDataHasRefreshedSinceApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/imported-data-refreshed-since`,
          params: {
            since_timestamp: queryArg.sinceTimestamp,
          },
        }),
        providesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1GetPlanGeneration: build.query<
        AutomationIntegrationApiV1GetPlanGenerationApiResponse,
        AutomationIntegrationApiV1GetPlanGenerationApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/plan-generation`,
        }),
        providesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1RequestPlanGeneration: build.mutation<
        AutomationIntegrationApiV1RequestPlanGenerationApiResponse,
        AutomationIntegrationApiV1RequestPlanGenerationApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/plan-generation`,
          method: "POST",
          body: queryArg.planGenerationAttemptIn,
        }),
        invalidatesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1RefreshImportedData: build.mutation<
        AutomationIntegrationApiV1RefreshImportedDataApiResponse,
        AutomationIntegrationApiV1RefreshImportedDataApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/refresh-imported-data`,
          method: "POST",
        }),
        invalidatesTags: ["Rainbow Data"],
      }),
      automationIntegrationApiV1CreateMockStatus: build.mutation<
        AutomationIntegrationApiV1CreateMockStatusApiResponse,
        AutomationIntegrationApiV1CreateMockStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/create-mock-status`,
          method: "POST",
          body: queryArg.mockStatusIn,
        }),
        invalidatesTags: ["Rainbow Data", "Order"],
      }),
      automationIntegrationApiV1MockImportedCtRtStructResponse: build.mutation<
        AutomationIntegrationApiV1MockImportedCtRtStructResponseApiResponse,
        AutomationIntegrationApiV1MockImportedCtRtStructResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/mock-imported-ct-rt-struct-response`,
          method: "POST",
          params: {
            response_type: queryArg.responseType,
          },
        }),
        invalidatesTags: ["Rainbow Data", "Order"],
      }),
      automationIntegrationApiV1MockPendingCtRtStructResponse: build.mutation<
        AutomationIntegrationApiV1MockPendingCtRtStructResponseApiResponse,
        AutomationIntegrationApiV1MockPendingCtRtStructResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/order/${queryArg.orderId}/mock-pending-ct-rt-struct-response`,
          method: "POST",
          params: {
            response_type: queryArg.responseType,
          },
        }),
        invalidatesTags: ["Rainbow Data", "Order"],
      }),
      automationIntegrationApiV1GetAutomationMetrics: build.query<
        AutomationIntegrationApiV1GetAutomationMetricsApiResponse,
        AutomationIntegrationApiV1GetAutomationMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/automation-metrics`,
          params: {
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
          },
        }),
        providesTags: ["Rainbow Data"],
      }),
      webApiV1ExportDashboardCsv: build.query<
        WebApiV1ExportDashboardCsvApiResponse,
        WebApiV1ExportDashboardCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/dashboard/export`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["Order"],
      }),
      webApiV1GetTenantConfig: build.query<
        WebApiV1GetTenantConfigApiResponse,
        WebApiV1GetTenantConfigApiArg
      >({
        query: () => ({ url: `/ord/api/v1/tenant_config` }),
        providesTags: ["TenantConfig"],
      }),
      iguanaApiV1GetPatient: build.query<
        IguanaApiV1GetPatientApiResponse,
        IguanaApiV1GetPatientApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/iguana/tenants/${queryArg.tenantId}/clinics/${queryArg.treatingDepartment}/patients/${queryArg.mrn}`,
        }),
        providesTags: ["Iguana"],
      }),
      iguanaApiV1SearchPatients: build.query<
        IguanaApiV1SearchPatientsApiResponse,
        IguanaApiV1SearchPatientsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/iguana/tenants/${queryArg.tenantId}/clinics/${queryArg.treatingDepartment}/patients`,
          params: {
            search_term: queryArg.searchTerm,
          },
        }),
        providesTags: ["Iguana"],
      }),
      iguanaApiV1GetCourses: build.query<
        IguanaApiV1GetCoursesApiResponse,
        IguanaApiV1GetCoursesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/iguana/tenants/${queryArg.tenantId}/clinics/${queryArg.treatingDepartment}/patients/${queryArg.mrn}/courses`,
        }),
        providesTags: ["Iguana"],
      }),
      iguanaApiV1ImportCourses: build.mutation<
        IguanaApiV1ImportCoursesApiResponse,
        IguanaApiV1ImportCoursesApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/iguana/tenants/${queryArg.tenantId}/clinics/${queryArg.treatingDepartment}/patients/${queryArg.mrn}/courses/import`,
          method: "POST",
          body: queryArg.selectedCourses,
        }),
        invalidatesTags: ["Iguana"],
      }),
      webApiV1ListAppointments: build.query<
        WebApiV1ListAppointmentsApiResponse,
        WebApiV1ListAppointmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/lumonus-ai/appointments`,
          params: {
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            user_filter: queryArg.userFilter,
          },
        }),
        providesTags: ["Appointments"],
      }),
      notificationsApiV1RegisterUserDevice: build.mutation<
        NotificationsApiV1RegisterUserDeviceApiResponse,
        NotificationsApiV1RegisterUserDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/notifications/register-device`,
          method: "POST",
          body: queryArg.registerDevice,
        }),
        invalidatesTags: ["Device"],
      }),
      notificationsApiV1IsDeviceRegistered: build.query<
        NotificationsApiV1IsDeviceRegisteredApiResponse,
        NotificationsApiV1IsDeviceRegisteredApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/notifications/register-device/${queryArg.deviceToken}`,
        }),
        providesTags: ["Device"],
      }),
      notificationsApiV1GetActivityCount: build.query<
        NotificationsApiV1GetActivityCountApiResponse,
        NotificationsApiV1GetActivityCountApiArg
      >({
        query: () => ({ url: `/ord/api/v1/notifications/activity/` }),
        providesTags: ["Notifications"],
      }),
      notificationsApiV1GetNotifications: build.query<
        NotificationsApiV1GetNotificationsApiResponse,
        NotificationsApiV1GetNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/notifications/device/${queryArg.deviceToken}`,
        }),
        providesTags: ["Notifications"],
      }),
      notificationsApiV1UpdateNotificationViewed: build.mutation<
        NotificationsApiV1UpdateNotificationViewedApiResponse,
        NotificationsApiV1UpdateNotificationViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/notifications/${queryArg.notificationId}`,
          method: "PATCH",
        }),
        invalidatesTags: ["Notifications"],
      }),
      notificationsApiV1UpdateNotifications: build.mutation<
        NotificationsApiV1UpdateNotificationsApiResponse,
        NotificationsApiV1UpdateNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/ord/api/v1/notifications/order-groups/${queryArg.orderGroupId}`,
          method: "PATCH",
          body: queryArg.notificationIn,
        }),
        invalidatesTags: ["Notifications"],
      }),
      notificationsApiV1GetPlanReviewNotificationCount: build.query<
        NotificationsApiV1GetPlanReviewNotificationCountApiResponse,
        NotificationsApiV1GetPlanReviewNotificationCountApiArg
      >({
        query: () => ({
          url: `/ord/api/v1/notifications/plan-review-notification-count/`,
        }),
        providesTags: ["External Lumonus AI"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as orderApi };
export type ProtocolApiV1ListProtocolsApiResponse =
  /** status 200 OK */ PagedProtocolInfoOut;
export type ProtocolApiV1ListProtocolsApiArg = {
  tenantId: number;
  limit?: number;
  offset?: number;
};
export type ProtocolApiV1ListDataApiResponse =
  /** status 200 OK */ ListDataOptionSerialisedOut[];
export type ProtocolApiV1ListDataApiArg = {
  categories?: string[];
  tenantIds?: number[];
};
export type ProtocolApiV1TreatmentSiteDataApiResponse =
  /** status 200 OK */ TreatmentSiteSerialised[];
export type ProtocolApiV1TreatmentSiteDataApiArg = {
  tenantId: number;
};
export type ProtocolApiV1OrganDataApiResponse =
  /** status 200 OK */ OrganSerialised[];
export type ProtocolApiV1OrganDataApiArg = {
  tenantId: number;
};
export type WebApiV1GetPatientApiResponse = /** status 200 OK */ PatientOut;
export type WebApiV1GetPatientApiArg = {
  patientId: number;
};
export type WebApiV1UpdatePatientApiResponse = /** status 200 OK */ PatientOut;
export type WebApiV1UpdatePatientApiArg = {
  patientId: number;
  patientIn: PatientIn;
};
export type WebApiV1OrderApiResponse = /** status 200 OK */ OrderOut;
export type WebApiV1OrderApiArg = {
  orderId: number;
};
export type WebApiV1UpdateOrderApiResponse = /** status 200 OK */ OrderOut;
export type WebApiV1UpdateOrderApiArg = {
  orderId: number;
  orderIn: OrderIn;
};
export type WebApiV1DeleteClonedOrderApiResponse = /** status 200 OK */ number;
export type WebApiV1DeleteClonedOrderApiArg = {
  orderId: number;
};
export type WebApiV1CreateOrderApiResponse = /** status 200 OK */ number;
export type WebApiV1CreateOrderApiArg = {
  tenantId?: number | null;
  treatingDepartment?: string | null;
};
export type WebApiV1ListOrdersApiResponse = /** status 200 OK */ PagedOrderOut;
export type WebApiV1ListOrdersApiArg = {
  ids?: string | null;
  recent?: boolean;
  filter?: "all" | "action";
  limit?: number;
  offset?: number;
};
export type WebApiV1CloneOrderApiResponse = /** status 200 OK */ number;
export type WebApiV1CloneOrderApiArg = {
  orderId: number;
};
export type WebApiV1RejectOrderApiResponse = /** status 200 OK */ OrderOut;
export type WebApiV1RejectOrderApiArg = {
  orderId: number;
  rejectOrderIn: RejectOrderIn;
};
export type WebApiV1CreateFhirOrderApiResponse =
  /** status 200 OK */ LumonusAiOrderOut;
export type WebApiV1CreateFhirOrderApiArg = {
  lumonusAiOrderIn: LumonusAiOrderIn;
};
export type WebApiV1VoidFhirOrderApiResponse = /** status 200 OK */ boolean;
export type WebApiV1VoidFhirOrderApiArg = {
  lumonusAiOrderIn: LumonusAiOrderIn;
};
export type WebApiV1OrderStatusChangeApiResponse =
  /** status 200 OK */ StatusChangeOut | null;
export type WebApiV1OrderStatusChangeApiArg = {
  orderId: number;
  statusName: string;
};
export type WebApiV1SearchOrdersApiResponse =
  /** status 200 OK */ OrderSearchOut[];
export type WebApiV1SearchOrdersApiArg = {
  searchText: string;
  siteFilter: string;
  physicianFilter: string;
  statusFilter: string;
  quickFilter: string;
  assignedToFilter: string;
  ordering: string;
};
export type WebApiV1RelatedPrescriptionsApiResponse =
  /** status 200 OK */ RelatedPrescriptionOut[];
export type WebApiV1RelatedPrescriptionsApiArg = {
  orderId: string;
};
export type WebApiV1GetRtStructsApiResponse =
  /** status 200 OK */ RtStructOut[];
export type WebApiV1GetRtStructsApiArg = {
  orderId: number;
};
export type WebApiV1GetIsocenterOptionsApiResponse =
  /** status 200 OK */ IsocenterOptionOut[];
export type WebApiV1GetIsocenterOptionsApiArg = {
  templateName: string;
  rtStructId: number;
  orderId: number;
};
export type WebApiV1SetOrderAssignmentApiResponse =
  /** status 200 OK */ OrderOut;
export type WebApiV1SetOrderAssignmentApiArg = {
  orderId: number;
  orderAssignmentIn: OrderAssignmentIn;
};
export type WebApiV1GetAllAssignablePlannersApiResponse =
  /** status 200 OK */ AssignablePlannerOut[];
export type WebApiV1GetAllAssignablePlannersApiArg = void;
export type WebApiV1GetTenantPhysiciansApiResponse =
  /** status 200 OK */ UserOptionOut[];
export type WebApiV1GetTenantPhysiciansApiArg = {
  tenantId?: number | null;
};
export type WebApiV1GetUserFeatureSwitchesApiResponse =
  /** status 200 OK */ any[];
export type WebApiV1GetUserFeatureSwitchesApiArg = void;
export type WebApiV1GetFeatureSwitchesForOrderApiResponse =
  /** status 200 OK */ any[];
export type WebApiV1GetFeatureSwitchesForOrderApiArg = {
  orderId: number;
};
export type WebApiV1GetUserPreferencesApiResponse =
  /** status 200 OK */ UserPreferenceOut;
export type WebApiV1GetUserPreferencesApiArg = void;
export type WebApiV1UpdateUserPreferencesApiResponse =
  /** status 200 OK */ boolean;
export type WebApiV1UpdateUserPreferencesApiArg = {
  userPreferenceIn: UserPreferenceIn;
};
export type WebApiV1ListSiteGroupsApiResponse =
  /** status 200 OK */ SiteGroupOut[];
export type WebApiV1ListSiteGroupsApiArg = {
  orderId: number;
};
export type WebApiV1CreateSiteGroupApiResponse =
  /** status 200 OK */ SiteGroupOut[];
export type WebApiV1CreateSiteGroupApiArg = {
  orderId: number;
  protocolId?: number | null;
  manualSiteName?: string | null;
  manualSiteSpecify?: string | null;
};
export type WebApiV1UpdateSiteGroupApiResponse =
  /** status 200 OK */ SiteGroupOut;
export type WebApiV1UpdateSiteGroupApiArg = {
  siteGroupId: number;
  siteGroupIn: SiteGroupIn;
};
export type WebApiV1DeleteSiteGroupApiResponse = unknown;
export type WebApiV1DeleteSiteGroupApiArg = {
  siteGroupId: number;
};
export type WebApiV1ListSitesApiResponse = /** status 200 OK */ SiteOut[];
export type WebApiV1ListSitesApiArg = {
  orderId: string;
  siteGroupId: string;
};
export type WebApiV1CreateSiteApiResponse = /** status 200 OK */ SiteOut;
export type WebApiV1CreateSiteApiArg = {
  siteGroupId: number;
  manualSiteName?: string | null;
  manualSiteSpecify?: string | null;
};
export type WebApiV1UpdateSiteApiResponse = /** status 200 OK */ SiteOut;
export type WebApiV1UpdateSiteApiArg = {
  siteId: number;
  siteOut: SiteOut;
};
export type WebApiV1DeleteSiteApiResponse = unknown;
export type WebApiV1DeleteSiteApiArg = {
  siteId: number;
};
export type WebApiV1ListOarsApiResponse = /** status 200 OK */ OrganAtRiskOut[];
export type WebApiV1ListOarsApiArg = {
  orderId: string;
  siteGroupId: string;
};
export type WebApiV1CreateOarApiResponse = /** status 200 OK */ OrganAtRiskOut;
export type WebApiV1CreateOarApiArg = {
  siteGroupId: number;
};
export type WebApiV1UpdateOarApiResponse = /** status 200 OK */ OrganAtRiskOut;
export type WebApiV1UpdateOarApiArg = {
  oarId: number;
  organAtRiskIn: OrganAtRiskIn;
};
export type WebApiV1DeleteOarApiResponse = unknown;
export type WebApiV1DeleteOarApiArg = {
  oarId: number;
};
export type WebApiV1ListTargetObjectivesApiResponse =
  /** status 200 OK */ TargetObjectiveOut[];
export type WebApiV1ListTargetObjectivesApiArg = {
  siteId: number;
};
export type WebApiV1UpdateTargetObjectiveApiResponse =
  /** status 200 OK */ TargetObjectiveOut;
export type WebApiV1UpdateTargetObjectiveApiArg = {
  siteId: number;
  targetObjectiveId: number;
  targetObjectiveIn: TargetObjectiveIn;
};
export type WebApiV1ListAttachmentsApiResponse =
  /** status 200 OK */ ScorecardAttachmentOut;
export type WebApiV1ListAttachmentsApiArg = {
  orderId: number;
};
export type WebApiV1CreateAttachmentApiResponse = unknown;
export type WebApiV1CreateAttachmentApiArg = {
  orderId: number;
  scorecardAttachmentIn: ScorecardAttachmentIn;
};
export type WebApiV1DeleteAttachmentApiResponse = unknown;
export type WebApiV1DeleteAttachmentApiArg = {
  orderId: number;
  attachmentId: number;
};
export type WebApiV1ReadAttachmentApiResponse = unknown;
export type WebApiV1ReadAttachmentApiArg = {
  orderId: number;
  attachmentId: number;
};
export type WebApiV1ListWalkthroughAttachmentsApiResponse =
  /** status 200 OK */ WalkthroughAttachmentOut[];
export type WebApiV1ListWalkthroughAttachmentsApiArg = {
  orderId: number;
};
export type WebApiV1CreateWalkthroughAttachmentUploadsApiResponse =
  /** status 200 OK */ WalkthroughAttachmentUpload[];
export type WebApiV1CreateWalkthroughAttachmentUploadsApiArg = {
  orderId: number;
  fileNames: string[];
};
export type WebApiV1DeleteWalkthroughAttachmentApiResponse = unknown;
export type WebApiV1DeleteWalkthroughAttachmentApiArg = {
  orderId: number;
  attachmentId: number;
};
export type WebApiV1UpdateWalkthroughAttachmentApiResponse =
  /** status 200 OK */ WalkthroughAttachmentOut;
export type WebApiV1UpdateWalkthroughAttachmentApiArg = {
  orderId: number;
  fileId: number;
  uploadComplete?: boolean | null;
  sentForReview?: boolean | null;
  read?: boolean | null;
};
export type CommentsApiV1GetCommentForOrderApiResponse =
  /** status 200 OK */ CommentOut[];
export type CommentsApiV1GetCommentForOrderApiArg = {
  orderGroupId: number;
};
export type CommentsApiV1PostCommentApiResponse = /** status 200 OK */ number;
export type CommentsApiV1PostCommentApiArg = {
  orderGroupId: number;
  commentIn: CommentIn;
};
export type CommentsApiV1CreateAttachmentApiResponse =
  /** status 200 OK */ UploadPayload;
export type CommentsApiV1CreateAttachmentApiArg = {
  orderGroupId: number;
  attachmentIn: AttachmentIn;
};
export type CommentsApiV1GetUnreadCommentCountApiResponse =
  /** status 200 OK */ number;
export type CommentsApiV1GetUnreadCommentCountApiArg = {
  orderGroupId: number;
};
export type CommentsApiV1GetAllUnreadCommentsApiResponse =
  /** status 200 OK */ OrderCommentCount[];
export type CommentsApiV1GetAllUnreadCommentsApiArg = void;
export type CommentsApiV1SetCommentsReadApiResponse =
  /** status 200 OK */ boolean;
export type CommentsApiV1SetCommentsReadApiArg = {
  orderGroupId: number;
};
export type WebApiV1UpdateUserActivityLastViewedApiResponse =
  /** status 200 OK */ string;
export type WebApiV1UpdateUserActivityLastViewedApiArg = void;
export type WebApiV1ResetDemoDataApiResponse = /** status 200 OK */ boolean;
export type WebApiV1ResetDemoDataApiArg = void;
export type AutomationIntegrationDeploymentApiV1GetRedisServerStatusApiResponse =
  /** status 200 OK */ RedisServerStatusOut;
export type AutomationIntegrationDeploymentApiV1GetRedisServerStatusApiArg = {
  tenantId: number;
};
export type AutomationIntegrationDeploymentApiV1GetConsumerInfoApiResponse =
  /** status 200 OK */ ConsumerInfoOut[];
export type AutomationIntegrationDeploymentApiV1GetConsumerInfoApiArg = {
  tenantId: number;
};
export type AutomationIntegrationDeploymentApiV1GetActiveJobsEndpointApiResponse =
  /** status 200 OK */ ActiveJobOut[];
export type AutomationIntegrationDeploymentApiV1GetActiveJobsEndpointApiArg = {
  tenantId: number;
};
export type AutomationIntegrationDeploymentApiV1GetPendingJobsEndpointApiResponse =
  /** status 200 OK */ PendingJobOut[];
export type AutomationIntegrationDeploymentApiV1GetPendingJobsEndpointApiArg = {
  tenantId: number;
};
export type AutomationIntegrationDeploymentApiV1DispatchHealthcheckRequestsApiResponse =
  /** status 200 OK */ {
    [key: string]: boolean;
  };
export type AutomationIntegrationDeploymentApiV1DispatchHealthcheckRequestsApiArg =
  {
    tenantIds: number[];
  };
export type AutomationIntegrationDeploymentApiV1GetHealthcheckInfoApiResponse =
  /** status 200 OK */ {
    [key: string]: AutomationServerDetailOut;
  };
export type AutomationIntegrationDeploymentApiV1GetHealthcheckInfoApiArg = {
  tenantIds: number[];
};
export type AutomationIntegrationDeploymentApiV1GetConsumerOverviewApiResponse =
  /** status 200 OK */ CustomerAutopintOut[];
export type AutomationIntegrationDeploymentApiV1GetConsumerOverviewApiArg = {
  tenantIds: number[];
};
export type AutomationIntegrationApiV1GetStructuresApiResponse =
  /** status 200 OK */ StructureSetResponse | null;
export type AutomationIntegrationApiV1GetStructuresApiArg = {
  orderId: number;
  rtStructId: number;
  sinceTimestamp?: string | null;
};
export type AutomationIntegrationApiV1RequestStructuresApiResponse =
  /** status 200 OK */ boolean;
export type AutomationIntegrationApiV1RequestStructuresApiArg = {
  orderId: number;
  rtStructId: number;
};
export type AutomationIntegrationApiV1ListTemplatesApiResponse =
  /** status 200 OK */ TemplateListSerialised[];
export type AutomationIntegrationApiV1ListTemplatesApiArg = {
  tenantId: number;
};
export type AutomationIntegrationApiV1ListTemplateDetailsApiResponse =
  /** status 200 OK */ TemplateOptionSerialised;
export type AutomationIntegrationApiV1ListTemplateDetailsApiArg = {
  tenantId: number;
  templateName: string;
};
export type AutomationIntegrationApiV1ListMachinesApiResponse =
  /** status 200 OK */ MachineSerialised[];
export type AutomationIntegrationApiV1ListMachinesApiArg = {
  tenantId: number;
};
export type AutomationIntegrationApiV1ListDensityOverridesApiResponse =
  /** status 200 OK */ DensityOverrideSerialised[];
export type AutomationIntegrationApiV1ListDensityOverridesApiArg = {
  tenantId: number;
};
export type AutomationIntegrationApiV1GetPlanningStepsApiResponse =
  /** status 200 OK */ PlanningStepSequence;
export type AutomationIntegrationApiV1GetPlanningStepsApiArg = {
  orderId: number;
};
export type AutomationIntegrationApiV1GetPlanningProgressApiResponse =
  /** status 200 OK */ PlanningProgress;
export type AutomationIntegrationApiV1GetPlanningProgressApiArg = {
  orderId: number;
};
export type AutomationIntegrationApiV1GetImportedDataHasRefreshedSinceApiResponse =
  /** status 200 OK */ ImportedDataHasRefreshedSinceResponse;
export type AutomationIntegrationApiV1GetImportedDataHasRefreshedSinceApiArg = {
  orderId: number;
  sinceTimestamp?: string | null;
};
export type AutomationIntegrationApiV1GetPlanGenerationApiResponse =
  /** status 200 OK */ PlanGenerationAttemptOut[];
export type AutomationIntegrationApiV1GetPlanGenerationApiArg = {
  orderId: number;
};
export type AutomationIntegrationApiV1RequestPlanGenerationApiResponse =
  /** status 200 OK */ boolean;
export type AutomationIntegrationApiV1RequestPlanGenerationApiArg = {
  orderId: number;
  planGenerationAttemptIn: PlanGenerationAttemptIn;
};
export type AutomationIntegrationApiV1RefreshImportedDataApiResponse =
  /** status 200 OK */ RefreshImportedDataResponse;
export type AutomationIntegrationApiV1RefreshImportedDataApiArg = {
  orderId: number;
};
export type AutomationIntegrationApiV1CreateMockStatusApiResponse =
  /** status 200 OK */ string;
export type AutomationIntegrationApiV1CreateMockStatusApiArg = {
  orderId: number;
  mockStatusIn: MockStatusIn;
};
export type AutomationIntegrationApiV1MockImportedCtRtStructResponseApiResponse =
  /** status 200 OK */ boolean;
export type AutomationIntegrationApiV1MockImportedCtRtStructResponseApiArg = {
  orderId: number;
  responseType: "empty" | "ct_only" | "ct_rt_struct";
};
export type AutomationIntegrationApiV1MockPendingCtRtStructResponseApiResponse =
  /** status 200 OK */ boolean;
export type AutomationIntegrationApiV1MockPendingCtRtStructResponseApiArg = {
  orderId: number;
  responseType: "empty" | "ct_only" | "ct_rt_struct";
};
export type AutomationIntegrationApiV1GetAutomationMetricsApiResponse =
  /** status 200 OK */ PlanGenerationAttemptOut[];
export type AutomationIntegrationApiV1GetAutomationMetricsApiArg = {
  startDate: string;
  endDate: string;
};
export type WebApiV1ExportDashboardCsvApiResponse = unknown;
export type WebApiV1ExportDashboardCsvApiArg = {
  start: string;
  end: string;
};
export type WebApiV1GetTenantConfigApiResponse =
  /** status 200 OK */ TenantConfigOut | null;
export type WebApiV1GetTenantConfigApiArg = void;
export type IguanaApiV1GetPatientApiResponse =
  /** status 200 OK */ PtPatientOut[];
export type IguanaApiV1GetPatientApiArg = {
  mrn: string;
  tenantId: number;
  treatingDepartment: string;
};
export type IguanaApiV1SearchPatientsApiResponse =
  /** status 200 OK */ PtPatientOut[];
export type IguanaApiV1SearchPatientsApiArg = {
  tenantId: number;
  treatingDepartment: string;
  searchTerm: string;
};
export type IguanaApiV1GetCoursesApiResponse =
  /** status 200 OK */ PtCourseListItemOut[];
export type IguanaApiV1GetCoursesApiArg = {
  mrn: string;
  tenantId: number;
  treatingDepartment: string;
};
export type IguanaApiV1ImportCoursesApiResponse = /** status 200 OK */ number;
export type IguanaApiV1ImportCoursesApiArg = {
  tenantId: number;
  treatingDepartment: string;
  mrn: string;
  selectedCourses: string[];
};
export type WebApiV1ListAppointmentsApiResponse =
  /** status 200 OK */ AppointmentOut[];
export type WebApiV1ListAppointmentsApiArg = {
  startDate: string | null;
  endDate: string | null;
  userFilter?: boolean;
};
export type NotificationsApiV1RegisterUserDeviceApiResponse =
  /** status 200 OK */ boolean;
export type NotificationsApiV1RegisterUserDeviceApiArg = {
  registerDevice: RegisterDevice;
};
export type NotificationsApiV1IsDeviceRegisteredApiResponse =
  /** status 200 OK */ boolean;
export type NotificationsApiV1IsDeviceRegisteredApiArg = {
  deviceToken: string;
};
export type NotificationsApiV1GetActivityCountApiResponse =
  /** status 200 OK */ number;
export type NotificationsApiV1GetActivityCountApiArg = void;
export type NotificationsApiV1GetNotificationsApiResponse =
  /** status 200 OK */ NotificationOut[];
export type NotificationsApiV1GetNotificationsApiArg = {
  deviceToken: string;
};
export type NotificationsApiV1UpdateNotificationViewedApiResponse =
  /** status 200 OK */ boolean;
export type NotificationsApiV1UpdateNotificationViewedApiArg = {
  notificationId: number;
};
export type NotificationsApiV1UpdateNotificationsApiResponse =
  /** status 200 OK */ boolean;
export type NotificationsApiV1UpdateNotificationsApiArg = {
  orderGroupId: number;
  notificationIn: NotificationIn;
};
export type NotificationsApiV1GetPlanReviewNotificationCountApiResponse =
  /** status 200 OK */ number;
export type NotificationsApiV1GetPlanReviewNotificationCountApiArg = void;
export type ProtocolInfoOut = {
  id: number;
  name: string;
  tumourStreams: string[];
  siteFilter: string;
  regions: string[];
  subregions: string[];
};
export type PagedProtocolInfoOut = {
  items: ProtocolInfoOut[];
  count: number;
};
export type ListDataOptionSerialisedOut = {
  value: string;
  category: string;
  listWeight: number;
  isActive: boolean;
  tenantName: string;
  tenantId: number;
};
export type TreatmentSiteSerialised = {
  name: string;
  default_laterality: string;
};
export type OrganSerialised = {
  name: string;
};
export type PatientOut = {
  id: number;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  medicalReferenceNumber: string | null;
};
export type PatientIn = {
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  medicalReferenceNumber?: string | null;
};
export type OrderStatus =
  | "draft"
  | "submitted"
  | "in_progress"
  | "ready_for_ro_approval"
  | "approved"
  | "completed"
  | "rejected"
  | "sent_to_automation"
  | "manual_plan";
export type StructureStatus = "complete" | "pending" | "skipped";
export type PlanningWarning = {
  updatedAt: string;
  message: string;
};
export type PlanGenerationResult = {
  planName: string;
  error: string;
  success: boolean;
  finishedAt: string;
};
export type OrderPlanGenerationAttemptOut = {
  planningStartedAt: string | null;
  currentStep: string;
  warnings: PlanningWarning[];
  result: PlanGenerationResult | null;
  stepSequence: string[];
  templateName: string;
  status: string;
  planProgressPercentage: number;
  currentStepIndex: number;
  relatedPrescription: string | null;
};
export type UserOut = {
  id: number;
  fullName: string;
};
export type AssignablePlannerOut = {
  id: number;
  fullName: string;
  workloadCount: number;
};
export type ImportOrigin = "iguana" | "lumonus_ai";
export type OrderOut = {
  id: number;
  patientName: string | null;
  patientMrn: string | null;
  patientDob: string | null;
  orderName: string | null;
  status: OrderStatus;
  treatingDepartment: string | null;
  treatingRo: string;
  planDelivery: string | null;
  submittedDatetime: string | null;
  handoverDatetime: string | null;
  ctStatus: StructureStatus;
  rtstructStatus: StructureStatus;
  isTest: boolean;
  latestPlanGenerationAttempt: OrderPlanGenerationAttemptOut | null;
  tenantId: number;
  lastRefreshedImportedDataAt: string | null;
  planReviewSummary: string | null;
  sentForReviewDatetime: string | null;
  assignedDosimetrist: UserOut | null;
  assignablePlanners: AssignablePlannerOut[];
  parentId: number | null;
  orderGroupId: number;
  createdAt: string | null;
  patientId: number | null;
  formattedStatus: string;
  additionalInfo: string | null;
  isLatest: boolean;
  latestChildId: number | null;
  treatingRoId: number | null;
  editingDatetime: string | null;
  approvedDatetime: string | null;
  approvedOnBehalfName: string | null;
  doseUnit: string;
  fractionUnit: string;
  machine: string | null;
  beamEnergy: string | null;
  importedFrom: ImportOrigin | null;
};
export type OrderIn = {
  treatingDepartment?: string | null;
  planDelivery?: string | null;
  status?: OrderStatus | null;
  additionalInfo?: string | null;
  isTest?: boolean | null;
  treatingRoId?: number | null;
  handoverDatetime?: string | null;
  planReviewSummary?: string | null;
};
export type PagedOrderOut = {
  items: OrderOut[];
  count: number;
};
export type RejectOrderIn = {
  rejectReason: string[];
  rejectedAdditionalInfo: string | null;
};
export type LumonusAiOrderOut = {
  orderId: number;
  orderGroupId: number;
  patientId: number;
};
export type LumonusAiPatientIn = {
  id: number;
  ida: string;
  dob: string;
  lastName: string;
  firstName: string;
};
export type LumonusAiCareplanIn = {
  id: number;
  name: string;
  priority: string;
  submittedDttm: string;
  treatingDepartment: string;
};
export type LumonusAiPractitionerIn = {
  id: number;
  name: string;
  email: string;
};
export type LumonusAiSubmittingUserIn = {
  name: string;
  email: string;
  username: string;
};
export type LumonusAiOrderIn = {
  patient: LumonusAiPatientIn;
  careplan: LumonusAiCareplanIn;
  practitioner: LumonusAiPractitionerIn;
  submittingUser: LumonusAiSubmittingUserIn;
};
export type StatusChangeOut = {
  id: number;
  orderId: number;
  status: OrderStatus;
  createdAt: string;
  updatedAt: string;
  createdBy: string | null;
};
export type OrderSearchOut = {
  id: number;
  patientName: string | null;
  patientMrn: string | null;
  patientDob: string | null;
  orderName: string | null;
  status: OrderStatus;
  treatingDepartment: string | null;
  treatingRo: string;
  planDelivery: string | null;
  submittedDatetime: string | null;
  handoverDatetime: string | null;
  ctStatus: StructureStatus;
  rtstructStatus: StructureStatus;
  isTest: boolean;
  latestPlanGenerationAttempt: OrderPlanGenerationAttemptOut | null;
  tenantId: number;
  lastRefreshedImportedDataAt: string | null;
  planReviewSummary: string | null;
  sentForReviewDatetime: string | null;
  assignedDosimetrist: UserOut | null;
  assignablePlanners: AssignablePlannerOut[];
  unreadCommentCount: number;
};
export type RelatedPrescriptionOut = {
  relatedPrescriptionName: string;
  relatedPrescriptionId: string;
};
export type RtStructOut = {
  id: number;
  seriesUid: string;
  studyDescription: string;
  studyDatetime?: string | null;
  seriesDescription: string;
  seriesDatetime: string;
  referencedCtUid: string;
  numberOfSlices: number;
  ctSeriesDescription?: string | null;
  ctSeriesDatetime?: string | null;
};
export type IsocenterOptionOut = {
  name: string;
  type: string;
  optionLabel: string;
  category: string;
};
export type OrderAssignmentIn = {
  assignedToId: number | null;
};
export type UserOptionOut = {
  id: number;
  name: string;
};
export type UserPreferenceOut = {
  statuses: string[];
  physicians: string[];
  treating_departments: string[];
  quick_filters: string[];
  assigned_to_filter: string[];
  tenant_ids: number[];
  preferred_role?: string | null;
};
export type UserPreferenceIn = {
  preferredRole?: string | null;
};
export type OrganAtRiskConstraintOut = {
  id: number;
  operator: string;
  firstValue?: number | null;
  secondValue?: number[] | null;
  isVolumeData?: boolean | null;
  firstValueUnit: string;
  secondValueUnit: string;
  prefixOperator?: string | null;
};
export type OrganAtRiskOut = {
  id: number;
  sortIndex: number;
  siteGroupId: number;
  alara?: boolean | null;
  organ: string;
  maxValue?: number[] | null;
  meanValue?: number[] | null;
  oarConstraints?: OrganAtRiskConstraintOut[] | null;
  constraints?: string | null;
  maxValueUnit?: string | null;
  meanValueUnit?: string | null;
  createdAt: string;
};
export type SiteOut = {
  id: string | number;
  siteGroupId: number;
  name: string;
  nameSpecify?: string | null;
  laterality: string;
  technique: string;
  sequence: string;
  isodose: string;
  highDose: number | null;
  lowDose?: number | null;
  mid1Dose?: number | null;
  mid2Dose?: number | null;
  fractions: number | null;
  frequency: string;
  energy: string;
  createdAt: string;
};
export type SiteGroupOut = {
  id: string | number;
  name: string;
  protocolId: number | null;
  protocolName: string | null;
  bolusActive: boolean;
  bolusFrequency: string | null;
  bolusLocation: string | null;
  bolusThickness: string | null;
  additionalInformation?: string | null;
  createdAt: string;
  organsAtRisk?: OrganAtRiskOut[] | null;
  sites?: SiteOut[] | null;
};
export type SiteGroupIn = {
  name?: string | null;
  bolusActive: boolean | null;
  bolusFrequency?: string | null;
  bolusLocation?: string | null;
  bolusThickness?: string | null;
  additionalInformation?: string | null;
};
export type OrganAtRiskIn = {
  id: number;
  sortIndex: number;
  siteGroupId: number;
  alara?: boolean | null;
  organ: string;
  maxValue?: number[] | null;
  meanValue?: number[] | null;
  oarConstraints?: OrganAtRiskConstraintOut[] | null;
  maxValueUnit?: string | null;
  meanValueUnit?: string | null;
};
export type TargetObjectiveOut = {
  id: number;
  siteId: number;
  doseType: string;
  gtv: string;
  ptv: string;
  ctv: string;
  createdAt: string;
};
export type TargetObjectiveIn = {
  gtv: string;
  ptv: string;
  ctv: string;
};
export type DosimetricCriteria = {
  Criterion: string;
  Outcome: string;
  Actual: string;
};
export type DvhStatistics = {
  Structure: string;
  DosimetricCriteria: DosimetricCriteria[];
  IsTarget?: boolean | null;
};
export type DvhStructureData = {
  StructureName: string;
  Colour: string;
  DVHPoints: number[][];
};
export type DvhChartData = {
  DoseUnit: string;
  DVHPointFields: string[];
  Structures: DvhStructureData[];
};
export type ScorecardObject = {
  DVHStatistics: DvhStatistics[];
  DVHData?: DvhChartData | null;
};
export type FileAttachmentOut = {
  id: number;
  scorecard?: string;
  scorecardObj: ScorecardObject;
  lastModifiedDate: string;
  createdAt: string;
  fileName: string;
  read: boolean;
};
export type ScorecardAttachmentOut = {
  id: number;
  scorecards: FileAttachmentOut[];
};
export type ScorecardAttachmentIn = {
  fileName: string;
  scorecard: ScorecardObject;
};
export type WalkthroughAttachmentOut = {
  id: number;
  lastModifiedDate: string;
  createdAt: string;
  file: string;
  fileName: string;
  fileSize: number;
  isValid: boolean;
  sentForReview: boolean;
  read: boolean;
};
export type PresignedFields = {
  AWSAccessKeyId?: string | null;
  key: string;
  policy: string;
  signature?: string | null;
  "x-amz-signature"?: string | null;
  "x-amz-security-token": string;
  "x-amz-credential"?: string | null;
  "x-amz-algorithm"?: string | null;
  "x-amz-date"?: string | null;
};
export type UploadPayload = {
  url: string;
  attachment_id?: number | null;
  fields: PresignedFields;
};
export type WalkthroughAttachmentUpload = {
  id: number;
  uploadUrl: UploadPayload;
  fileName: string;
};
export type CommentAttachmentOut = {
  id: number;
  fileName: string;
  url: string;
};
export type CommentOut = {
  id: number;
  createdBy: string;
  creatorRole: string;
  content?: string | null;
  createdAt?: string | null;
  attachments: CommentAttachmentOut[];
};
export type CommentIn = {
  orderId: number;
  content: string;
  attachmentIds?: number[] | null;
};
export type AttachmentIn = {
  fileName: string;
};
export type OrderCommentCount = {
  orderGroupId: number;
  commentCount: number;
};
export type RedisServerStatusOut = {
  connected: boolean;
  redisVersion?: string | null;
  uptimeInSeconds?: number | null;
  connectedClients?: number | null;
  usedMemoryHuman?: string | null;
  totalCommandsProcessed?: number | null;
  error?: string | null;
};
export type ConsumerInfoOut = {
  groupName?: string | null;
  consumerName?: string | null;
  idleMillis: number;
};
export type ActiveJobOut = {
  jobId: string;
  consumerName: string | null;
  elapsedTimeMs: number;
  retryCount: number;
  groupName: string;
  streamName: string;
};
export type PendingJobOut = {
  groupName: string;
  streamName: string;
  pendingCount: number;
};
export type AutomationServerDetailOut = {
  appName: string;
  appVersion: string;
  recipeVersion: string;
  appLastUpdatedAt: string;
  lastHealthcheckAt: string;
  serverName: string;
  isLatest: boolean;
  message?: string | null;
};
export type ConsumersOut = {
  planGenConsumers: ConsumerInfoOut[];
  otherConsumers: ConsumerInfoOut[];
};
export type ConsumerGroupOut = {
  streamName: string;
  groupName: string;
  lag: number;
};
export type ConsumerGroupsOut = {
  planGenGroups: ConsumerGroupOut[];
  otherGroups: ConsumerGroupOut[];
};
export type CustomerAutopintOut = {
  tenantName: string;
  tenantId: number;
  tps: string;
  consumers: ConsumersOut;
  groups: ConsumerGroupsOut;
  error?: string | null;
  connected: boolean;
  lastUpdated: string;
};
export type StructureSetEntry = {
  name: string;
  type: string;
};
export type StructureSetResponse = {
  structures: StructureSetEntry[];
  error?: string | null;
};
export type TemplateListSerialised = {
  name: string;
  description?: string | null;
  doseLevelDisplay?: string | null;
};
export type TemplateStructure = {
  name: string;
  mandatory: boolean;
  regex: string | string[] | null;
  isIsocenter: boolean;
};
export type TemplateOptionSerialised = {
  name: string;
  data: TemplateStructure[];
};
export type MachineSerialised = {
  id: number;
  name: string;
  beam_energies: string[];
};
export type DensityOverrideSerialised = {
  id: number;
  name: string;
  regex: string;
  density: number;
  material_id: string;
};
export type PlanningStepSequence = {
  steps: string[];
};
export type PlanningProgress = {
  planningStartedAt: string | null;
  currentStep: string;
  warnings: PlanningWarning[];
  result: PlanGenerationResult | null;
  templateName: string;
};
export type ImportedDataHasRefreshedSinceResponse = {
  hasRefreshedSince: boolean;
  lastRefreshedAt?: string | null;
};
export type PlanGenerationStepOut = {
  step: string;
  steppedAt: string | null;
};
export type PlanGenerationAttemptOut = {
  id: number;
  planningStartedAt: string | null;
  currentStep: string;
  warnings: PlanningWarning[];
  planGenerationSteps?: PlanGenerationStepOut[] | null;
  planName: string | null;
  error: string | null;
  success: boolean;
  machine: string;
  beamEnergy: string;
  templateName: string;
  finishedAt: string | null;
  relatedPrescription: string | null;
  relatedPrescriptionId: string | null;
  tenantName: string;
  orderId: number;
};
export type DensityOverrideEntry = {
  material: string;
  structure: string;
};
export type PlanGenerationAttemptIn = {
  template: string;
  structures: StructureSetEntry[];
  machine: string;
  beam_energy: string;
  related_prescription: string | null;
  related_prescription_id: string | null;
  density_overrides?: DensityOverrideEntry[] | null;
  rt_struct_id: number;
  isocentre?: StructureSetEntry | null;
};
export type RefreshImportedDataResponse = {
  lastRefreshedAt?: string | null;
};
export type MockStatusIn = {
  statusType: string;
  eventDetails: string | string[] | null;
};
export type TpsOptions = "monaco" | "eclipse";
export type TenantConfigOut = {
  id: number;
  lumonus_ai_frontend_url?: string | null;
  support_email?: string | null;
  tps?: TpsOptions | null;
};
export type PtPatientOut = {
  firstName: string;
  lastName: string;
  dateOfBirth?: string | null;
  patientId: string;
};
export type PtSiteListItemOut = {
  prescriptionName: string;
  prescriptionSer: number;
};
export type PtCourseListItemOut = {
  courseId: string;
  sites: PtSiteListItemOut[];
  lastModifiedDate?: string | null;
};
export type Patient = {
  id: number;
  firstName: string;
  lastName: string;
  dob: string | null;
};
export type AppointmentOut = {
  id: number;
  patient: Patient | null;
  startTime: string;
  duration: string | null;
  status: string;
  description: string | null;
  location: string | null;
  comment: string | null;
  activity: string | null;
  department: string | null;
  appointmentType: string;
  appointmentCategory: string;
};
export type RegisterDevice = {
  deviceToken: string;
};
export type NotificationOut = {
  id: number | null;
  orderId: number | null;
  latestOrderId: number | null;
  latestOrderStatus: string | null;
  orderGroupId: number | null;
  content: string | null;
  viewed: boolean | null;
  createdAt: string;
  patientName: string | null;
  patientDob: string | null;
  patientMrn: string | null;
  notificationType: string | null;
  createdBy: string | null;
};
export type NotificationIn = {
  notificationType: string;
};
export const {
  useProtocolApiV1ListProtocolsQuery,
  useLazyProtocolApiV1ListProtocolsQuery,
  useProtocolApiV1ListDataQuery,
  useLazyProtocolApiV1ListDataQuery,
  useProtocolApiV1TreatmentSiteDataQuery,
  useLazyProtocolApiV1TreatmentSiteDataQuery,
  useProtocolApiV1OrganDataQuery,
  useLazyProtocolApiV1OrganDataQuery,
  useWebApiV1GetPatientQuery,
  useLazyWebApiV1GetPatientQuery,
  useWebApiV1UpdatePatientMutation,
  useWebApiV1OrderQuery,
  useLazyWebApiV1OrderQuery,
  useWebApiV1UpdateOrderMutation,
  useWebApiV1DeleteClonedOrderMutation,
  useWebApiV1CreateOrderMutation,
  useWebApiV1ListOrdersQuery,
  useLazyWebApiV1ListOrdersQuery,
  useWebApiV1CloneOrderMutation,
  useWebApiV1RejectOrderMutation,
  useWebApiV1CreateFhirOrderMutation,
  useWebApiV1VoidFhirOrderMutation,
  useWebApiV1OrderStatusChangeQuery,
  useLazyWebApiV1OrderStatusChangeQuery,
  useWebApiV1SearchOrdersQuery,
  useLazyWebApiV1SearchOrdersQuery,
  useWebApiV1RelatedPrescriptionsQuery,
  useLazyWebApiV1RelatedPrescriptionsQuery,
  useWebApiV1GetRtStructsQuery,
  useLazyWebApiV1GetRtStructsQuery,
  useWebApiV1GetIsocenterOptionsQuery,
  useLazyWebApiV1GetIsocenterOptionsQuery,
  useWebApiV1SetOrderAssignmentMutation,
  useWebApiV1GetAllAssignablePlannersQuery,
  useLazyWebApiV1GetAllAssignablePlannersQuery,
  useWebApiV1GetTenantPhysiciansQuery,
  useLazyWebApiV1GetTenantPhysiciansQuery,
  useWebApiV1GetUserFeatureSwitchesQuery,
  useLazyWebApiV1GetUserFeatureSwitchesQuery,
  useWebApiV1GetFeatureSwitchesForOrderQuery,
  useLazyWebApiV1GetFeatureSwitchesForOrderQuery,
  useWebApiV1GetUserPreferencesQuery,
  useLazyWebApiV1GetUserPreferencesQuery,
  useWebApiV1UpdateUserPreferencesMutation,
  useWebApiV1ListSiteGroupsQuery,
  useLazyWebApiV1ListSiteGroupsQuery,
  useWebApiV1CreateSiteGroupMutation,
  useWebApiV1UpdateSiteGroupMutation,
  useWebApiV1DeleteSiteGroupMutation,
  useWebApiV1ListSitesQuery,
  useLazyWebApiV1ListSitesQuery,
  useWebApiV1CreateSiteMutation,
  useWebApiV1UpdateSiteMutation,
  useWebApiV1DeleteSiteMutation,
  useWebApiV1ListOarsQuery,
  useLazyWebApiV1ListOarsQuery,
  useWebApiV1CreateOarMutation,
  useWebApiV1UpdateOarMutation,
  useWebApiV1DeleteOarMutation,
  useWebApiV1ListTargetObjectivesQuery,
  useLazyWebApiV1ListTargetObjectivesQuery,
  useWebApiV1UpdateTargetObjectiveMutation,
  useWebApiV1ListAttachmentsQuery,
  useLazyWebApiV1ListAttachmentsQuery,
  useWebApiV1CreateAttachmentMutation,
  useWebApiV1DeleteAttachmentMutation,
  useWebApiV1ReadAttachmentMutation,
  useWebApiV1ListWalkthroughAttachmentsQuery,
  useLazyWebApiV1ListWalkthroughAttachmentsQuery,
  useWebApiV1CreateWalkthroughAttachmentUploadsMutation,
  useWebApiV1DeleteWalkthroughAttachmentMutation,
  useWebApiV1UpdateWalkthroughAttachmentMutation,
  useCommentsApiV1GetCommentForOrderQuery,
  useLazyCommentsApiV1GetCommentForOrderQuery,
  useCommentsApiV1PostCommentMutation,
  useCommentsApiV1CreateAttachmentMutation,
  useCommentsApiV1GetUnreadCommentCountQuery,
  useLazyCommentsApiV1GetUnreadCommentCountQuery,
  useCommentsApiV1GetAllUnreadCommentsQuery,
  useLazyCommentsApiV1GetAllUnreadCommentsQuery,
  useCommentsApiV1SetCommentsReadMutation,
  useWebApiV1UpdateUserActivityLastViewedMutation,
  useWebApiV1ResetDemoDataMutation,
  useAutomationIntegrationDeploymentApiV1GetRedisServerStatusQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetRedisServerStatusQuery,
  useAutomationIntegrationDeploymentApiV1GetConsumerInfoQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetConsumerInfoQuery,
  useAutomationIntegrationDeploymentApiV1GetActiveJobsEndpointQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetActiveJobsEndpointQuery,
  useAutomationIntegrationDeploymentApiV1GetPendingJobsEndpointQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetPendingJobsEndpointQuery,
  useAutomationIntegrationDeploymentApiV1DispatchHealthcheckRequestsMutation,
  useAutomationIntegrationDeploymentApiV1GetHealthcheckInfoQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetHealthcheckInfoQuery,
  useAutomationIntegrationDeploymentApiV1GetConsumerOverviewQuery,
  useLazyAutomationIntegrationDeploymentApiV1GetConsumerOverviewQuery,
  useAutomationIntegrationApiV1GetStructuresQuery,
  useLazyAutomationIntegrationApiV1GetStructuresQuery,
  useAutomationIntegrationApiV1RequestStructuresMutation,
  useAutomationIntegrationApiV1ListTemplatesQuery,
  useLazyAutomationIntegrationApiV1ListTemplatesQuery,
  useAutomationIntegrationApiV1ListTemplateDetailsQuery,
  useLazyAutomationIntegrationApiV1ListTemplateDetailsQuery,
  useAutomationIntegrationApiV1ListMachinesQuery,
  useLazyAutomationIntegrationApiV1ListMachinesQuery,
  useAutomationIntegrationApiV1ListDensityOverridesQuery,
  useLazyAutomationIntegrationApiV1ListDensityOverridesQuery,
  useAutomationIntegrationApiV1GetPlanningStepsQuery,
  useLazyAutomationIntegrationApiV1GetPlanningStepsQuery,
  useAutomationIntegrationApiV1GetPlanningProgressQuery,
  useLazyAutomationIntegrationApiV1GetPlanningProgressQuery,
  useAutomationIntegrationApiV1GetImportedDataHasRefreshedSinceQuery,
  useLazyAutomationIntegrationApiV1GetImportedDataHasRefreshedSinceQuery,
  useAutomationIntegrationApiV1GetPlanGenerationQuery,
  useLazyAutomationIntegrationApiV1GetPlanGenerationQuery,
  useAutomationIntegrationApiV1RequestPlanGenerationMutation,
  useAutomationIntegrationApiV1RefreshImportedDataMutation,
  useAutomationIntegrationApiV1CreateMockStatusMutation,
  useAutomationIntegrationApiV1MockImportedCtRtStructResponseMutation,
  useAutomationIntegrationApiV1MockPendingCtRtStructResponseMutation,
  useAutomationIntegrationApiV1GetAutomationMetricsQuery,
  useLazyAutomationIntegrationApiV1GetAutomationMetricsQuery,
  useWebApiV1ExportDashboardCsvQuery,
  useLazyWebApiV1ExportDashboardCsvQuery,
  useWebApiV1GetTenantConfigQuery,
  useLazyWebApiV1GetTenantConfigQuery,
  useIguanaApiV1GetPatientQuery,
  useLazyIguanaApiV1GetPatientQuery,
  useIguanaApiV1SearchPatientsQuery,
  useLazyIguanaApiV1SearchPatientsQuery,
  useIguanaApiV1GetCoursesQuery,
  useLazyIguanaApiV1GetCoursesQuery,
  useIguanaApiV1ImportCoursesMutation,
  useWebApiV1ListAppointmentsQuery,
  useLazyWebApiV1ListAppointmentsQuery,
  useNotificationsApiV1RegisterUserDeviceMutation,
  useNotificationsApiV1IsDeviceRegisteredQuery,
  useLazyNotificationsApiV1IsDeviceRegisteredQuery,
  useNotificationsApiV1GetActivityCountQuery,
  useLazyNotificationsApiV1GetActivityCountQuery,
  useNotificationsApiV1GetNotificationsQuery,
  useLazyNotificationsApiV1GetNotificationsQuery,
  useNotificationsApiV1UpdateNotificationViewedMutation,
  useNotificationsApiV1UpdateNotificationsMutation,
  useNotificationsApiV1GetPlanReviewNotificationCountQuery,
  useLazyNotificationsApiV1GetPlanReviewNotificationCountQuery,
} = injectedRtkApi;
